// AUTO-GENERATED by scripts/sync-logos.ts. Do not edit by hand.
// Run `pnpm --filter @memkernel/web build:logos` to regenerate.

export const INTEGRATION_COLORS: Record<string, string> = {
  "github": "#181717",
  "gmail": "#EA4335",
  "slack": "#4A154B",
  "notion": "#000000",
  "googlesheets": "#34A853",
  "shopify": "#7AB55C",
  "googledrive": "#4285F4",
  "supabase": "#3FCF8E",
  "hubspot": "#FF7A59",
  "linear": "#5E6AD2",
  "jira": "#0052CC",
  "asana": "#F06A6A",
  "trello": "#0052CC",
  "clickup": "#7B68EE",
  "monday": "#FF3D57",
  "salesforce": "#00A1E0",
  "stripe": "#635BFF",
  "zoom": "#0B5CFF",
  "calendly": "#006BFF",
  "microsoft_teams": "#52525B",
  "outlook": "#52525B",
  "googlecalendar": "#4285F4",
  "dropbox": "#0061FF",
  "airtable": "#18BFFF",
  "discord": "#5865F2",
  "telegram": "#26A5E4",
  "whatsapp": "#25D366",
  "twitter": "#52525B",
  "linkedin": "#0A66C2",
  "youtube": "#FF0000",
  "facebook": "#0866FF",
  "instagram": "#FF0069",
  "tiktok": "#000000",
  "reddit": "#FF4500",
  "mailchimp": "#FFE01B",
  "sendgrid": "#51A9E3",
  "klaviyo": "#1F2123",
  "intercom": "#6AFDEF",
  "zendesk": "#03363D",
  "freshdesk": "#52525B",
  "figma": "#F24E1E",
  "miro": "#050038",
  "canva": "#00C4CC",
  "openai": "#412991",
  "gemini": "#52525B",
  "perplexityai": "#52525B",
  "anthropic_administrator": "#52525B",
  "elevenlabs": "#000000",
  "pinecone": "#1B6BF9",
  "replicate": "#000000",
  "firecrawl": "#52525B",
  "tavily": "#52525B",
  "exa": "#52525B",
  "serpapi": "#52525B",
  "apify": "#52525B",
  "browserbase_tool": "#52525B",
  "brightdata": "#52525B",
  "amplitude": "#1E61F0",
  "mixpanel": "#7856FF",
  "segment": "#52BD94",
  "posthog": "#000000",
  "google_analytics": "#52525B",
  "datadog": "#632CA6",
  "sentry": "#362D59",
  "pagerduty": "#06AC38",
  "grafana": "#F46800",
  "bugsnag": "#4949E4",
  "snowflake": "#29B5E8",
  "databricks": "#FF3621",
  "googlebigquery": "#669DF6",
  "metabase": "#509EE3",
  "pipedrive": "#1A1A1A",
  "zoho": "#E42527",
  "attio": "#52525B",
  "close": "#52525B",
  "apollo": "#52525B",
  "paypal": "#003087",
  "square": "#3E4348",
  "razorpay": "#0C2451",
  "quickbooks": "#2CA01C",
  "xero": "#13B5EA",
  "docusign": "#52525B",
  "dropbox_sign": "#52525B",
  "typeform": "#262627",
  "jotform": "#FF6100",
  "eventbrite": "#F05537",
  "googleads": "#4285F4",
  "metaads": "#52525B",
  "linkedin_ads": "#52525B",
  "reddit_ads": "#52525B",
  "webflow": "#146EF5",
  "resend": "#000000",
  "contentful": "#2478CC",
  "sanity": "#F03E2F",
  "prismic": "#5163BA",
  "spotify": "#1ED760",
  "google_chat": "#52525B",
  "neon": "#00E699",
  "algolia": "#003DFF",
  "cloudflare": "#F38020",
};
